import { AnchorButton } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, useText } from "@sveabank/cc-common";
import { Link } from "react-router";
import { usePages } from "../../../hooks/usePages";

type Props = { isOpen: boolean };

const CreditProductsRemovedModal = ({ isOpen }: Props) => {
	const [t, texts] = useText();
	const { nextPage } = usePages();

	return (
		<Dialog
			isOpen={isOpen}
			isDismissable={false}
			size="small"
			heading={t(texts.adjustCredit.noAddonsModal.title)}
		>
			<Dialog.Content>{t(texts.adjustCredit.noAddonsModal.description)}</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					{nextPage && (
						<AnchorButton as={Link} width="full" to={nextPage}>
							{t(texts.common.okContinue)}
						</AnchorButton>
					)}
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};

export default CreditProductsRemovedModal;
